import { isValidEmail } from 'modules/core/lib/email'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

type ValidateEmailType = 'empty' | 'terminated' | 'existing_employee' | 'invalid_email'

export type EmailValidation = {
  valid: boolean
  errorType?: ValidateEmailType
  errorString?: string
}

export const validateEmailForCreation = (email: string): EmailValidation => {
  if (!email) return { valid: false, errorType: 'empty' }

  const user = users.find({
    email,
  })

  const existingEmployee = user?.employee

  if (existingEmployee?.isTerminated) {
    return {
      valid: false,
      errorType: 'terminated',
      errorString: i18n.t('employee_form.onboarding.existing_employee_terminated'),
    }
  }

  if (existingEmployee) {
    return {
      valid: false,
      errorType: 'existing_employee',
      errorString: i18n.t('employee_form.onboarding.existing_employee'),
    }
  }

  if (!isValidEmail(email)) {
    return {
      valid: false,
      errorType: 'invalid_email',
      errorString: i18n.t('employee_form.onboarding.invalid_email'),
    }
  }

  return {
    valid: true,
  }
}
